import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface StepNextButtonProps {
  onClick: () => void;
  disabled?: boolean;
  isLoading?: boolean;
}

export const StepNextButton = ({
  onClick,
  disabled,
  isLoading,
}: StepNextButtonProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);

  return (
    <Button
      type="button"
      size="lg"
      icon="trailing"
      className="min-w-37 w-fit"
      disabled={disabled}
      isLoading={isLoading}
      onClick={onClick}
    >
      {t('AppointmentsReserve.next')}
      <ChevronRight className="size-6" />
    </Button>
  );
};
